<template>
  <div>
    <el-container>

      <el-main>

        <br>
        <el-row>
          <el-col :span="8"
                  :offset="3">
            <el-card :body-style="{ padding: '0px',width:'100%',margin:'auto' }">
              <div class="simpleReportImg">
                <div class="demoTitle">个股分析报告</div>
              </div>
              <div class="reportDemoDesc">
                <div>
                  快速清洗、加工、整合海量财经数据，一键生成个股深度分析报告，为用户的分析决策提供智能化建议
                </div>
              </div>
              <div style="text-align:center">
                <el-button round
                           @click="showPdf(0)"
                           class="demoBtn">查看样例

                  <i class="iconfont">&#xe604;</i>
                </el-button>
                <br /> <br />
              </div>
            </el-card>
          </el-col>
          <el-col :span="8"
                  :offset="2">
            <el-card :body-style="{ padding: '0px',width:'100%',margin:'auto' }">
              <div class="tinyReportImg">
                <div class="demoTitle">财务分析报告</div>
              </div>
              <div class="reportDemoDesc">
                <div>
                  财务健康诊断、财务问题发现。
                </div>
              </div>
              <div style="text-align:center">
                <el-button round
                           @click="showPdf(1)"
                           class="demoBtn">查看样例
                  <i class="iconfont">&#xe604;</i>
                </el-button> <br /> <br />
              </div>
            </el-card>
          </el-col>

        </el-row>
        <br> <br> <br>
        <el-row>
          <el-col :span="8"
                  :offset="3">
            <el-card :body-style="{ padding: '0px',width:'100%',margin:'auto' }">
              <div class="compareReportImg">
                <div class="demoTitle">投资组合报告</div>
              </div>
              <div class="reportDemoDesc">
                <div>
                  用户自选一组股票，
                  一键生成投资组合报告，
                  综合对比股票各方面情况，
                  快速形成立体认识。
                </div>
              </div>
              <div style="text-align:center">
                <el-button round
                           @click="showPdf(2)"
                           class="demoBtn">查看样例
                  <i class="iconfont">&#xe604;</i>
                </el-button> <br /> <br />
              </div>
            </el-card>
          </el-col>
          <el-col :span="8"
                  :offset="2">
            <el-card :body-style="{ padding: '0px',width:'100%',margin:'auto' }">
              <div class="conceptReportImg">
                <div class="demoTitle">概念感知报告</div>
              </div>
              <div class="reportDemoDesc">
                <div>
                  专注概念板块基本面、技术面和消息面的
                  多维分析，快速全面了解热门概念整体情况，
                  为用户的分析决策提供智能化建议。
                </div>
              </div>
              <div style="text-align:center">
                <el-button round
                           @click="showPdf(3)"
                           class="demoBtn">查看样例
                  <i class="iconfont">&#xe604;</i>
                </el-button> <br /> <br />
              </div>
            </el-card>
          </el-col>

        </el-row>

      </el-main>

    </el-container>

    <el-dialog width="500"
               top="0"
               :visible.sync="pdfDialogVisible">
      <iframe :src="pdfUrl"
              style="width: 100%;
    height: calc(100vh - 120px);
    border: 0;" />
      <div style="width:100%;text-align:center">
        <!-- <el-button @click="toDownPdf(curSourceId)"
                   size="small">下载</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'myReports',
  data: function () {
    return {
      tableLoading: true,
      pdfDialogVisible: false,
      pdfUrl: '',
      sourceId: '',
      pdfSource: [
        './static/pdf/simple.pdf',
        './static/pdf/finance.pdf',
        './static/pdf/compare.pdf',
        './static/pdf/concept.pdf'
      ]
    }
  },
  filters: {

  },
  methods: {
    showPdf (index) {
      this.pdfUrl = this.pdfSource[index]
      // eslint-disable-next-line no-undef
      _hmt.push(['_trackEvent', '浏览报告样例', this.pdfUrl])
      this.pdfDialogVisible = true
    }
  },

  mounted () {
    // eslint-disable-next-line no-undef

  }
}
</script>
<style lang="less" scoped>
.demoTitle {
  justify-items: center;
  margin: auto;
  text-align: center;
  color: white;
  font-size: 32px;
  line-height: 155px;
}
.el-card {
  min-width: 400px;
}
.container-fluid {
  background: url("/static/img/courses-header.jpg");
  height: 400px;
}

.simpleReportImg {
  width: 100%;
  height: 160px;
  background: url("../assets/imgs/simpleReportDemoBg.jpg");
}
.tinyReportImg {
  width: 100%;
  height: 160px;
  background: url("../assets/imgs/tinyReportDemoBg.jpg");
}
.compareReportImg {
  width: 100%;
  height: 160px;
  background: url("../assets/imgs/compareReportDemoBg.jpg");
}
.conceptReportImg {
  width: 100%;
  height: 160px;
  background: url("../assets/imgs/conceptDemoBg.jpg");
}

.reportDemoDesc {
  text-align: center;
  padding: 20px;
  font-size: 0.9rem;

  div {
    width: 340px;
    margin: auto;
    height: 50px;
    justify-content: center;
    justify-items: center;
    align-items: center;
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/app/home.vue